(ns arthur.ui.topbar
  "The strip across the top: what document this is, and the three things you can
  do to the whole of it.

  Save, open and export are here rather than in a pane because none of them is a
  property of a selection — they act on the document, and the document is the
  window."
  (:require [arthur.events.collab :as collab]
            [arthur.events.export :as export]
            [arthur.events.project :as project]
            [arthur.subs.playback :as playback]
            [arthur.ui.layout :as layout]
            [arthur.ui.openmenu :as openmenu]
            [arthur.ui.settings :as settings]
            [arthur.ui.share :as share]
            [arthur.ui.shortcuts :as shortcuts]
            [arthur.ui.snapshots :as snapshots]
            [arthur.ui.undo :as undo]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(defn- exporter [open?]
  (let [{:keys [target zoom busy? done total]} @(rf/subscribe [::export/state])
        targets @(rf/subscribe [::export/targets])]
    [:<>
     [:button {:disabled busy? :on-click #(reset! open? true)} "export…"]
     (when @open?
       [:<> [:div.export-scrim {:on-click #(when-not busy? (reset! open? false))}]
        [:section.export-dialog {:role "dialog" :aria-modal true :aria-label "Export"}
         [:h2 "Export"]
         [:label.export-field "what to render"
          [:select {:value (export/target-value target) :disabled busy?
                    :on-change #(rf/dispatch [::export/set-target
                                              (export/target-id (.. % -target -value))])}
           (doall (for [{:keys [label] :as t} targets]
                    ^{:key (export/target-value t)}
                    [:option {:value (export/target-value t)}
                     (str (when (:isolate t) "· ") label)]))]]
         [:label.export-field "scale"
          [:select {:value zoom :disabled busy?
                    :on-change #(rf/dispatch [::export/set-zoom
                                              (js/parseInt (.. % -target -value) 10)])}
           (doall (for [z export/zooms] ^{:key z} [:option {:value z} (str z "×")]))]]
         [:p.dim "PNG sequence and audio in a ZIP archive"]
         [:div.row
          [:button {:disabled busy? :on-click #(rf/dispatch [::export/start])}
           (if busy? (str "rendering " done "/" total) "start export")]
          [:button {:disabled busy? :on-click #(reset! open? false)} "close"]]]])]))

(defn view []
  (r/with-let [renaming? (r/atom false)
               draft (r/atom "")
               export-open? (r/atom false)]
    (let [{project-name :name project-seq :seq :keys [busy? status]} @(rf/subscribe [::playback/project])
          {footage-status :status} @(rf/subscribe [::playback/footage])
          {export-status :status} @(rf/subscribe [::export/state])
          title (or project-name "untitled")
          commit! (fn []
                    (rf/dispatch [::project/rename @draft])
                    (reset! renaming? false))]
      [:header.top
       [:a.brand {:href "/" :title "your projects"
                  :on-click (fn [e] (.preventDefault e) (collab/navigate! "/"))} "arthur"]
       ;; At the left end, before the document's own commands: on a narrow window
       ;; this strip scrolls, and which panes are open is the one control that
       ;; must not be the thing off the end of it.
       [layout/panes]
       [settings/new-project "new"]
       [openmenu/view]
       [undo/view]
       [snapshots/view]
       (if @renaming?
         [:input.project-name {:auto-focus true :value @draft
                               :on-change #(reset! draft (.. % -target -value))
                               :on-blur (fn [_] (commit!))
                               :on-key-down (fn [e]
                                              (case (.-key e)
                                                "Enter" (do (.preventDefault e) (commit!))
                                                "Escape" (reset! renaming? false)
                                                nil))}]
         [:button.project-title {:disabled busy? :title "click to rename project"
                                 :on-click (fn [] (reset! draft title)
                                             (reset! renaming? true))}
          title (when project-seq (str " r" project-seq))])
       [:span.status (or export-status status footage-status)]
       [exporter export-open?]
       [share/view]
       [shortcuts/button]])))
